export const HEAD_TABLE_PROPS = [
  {
    id: 'ID',
    label: 'ID',
    align: 'center',
  },
  {
    id: 'name',
    label: 'Tên',
    align: 'center',
  },
  {
    id: 'description',
    label: 'Mô tả',
    align: 'center',
  },
  { label: '', align: 'center' },
];
